import type { MessageChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import type { ReactNode } from "react";
import { memo } from "react";
import {
  MessageChannelIcons,
  MessageChannelReadable,
} from "../ui/thread-channel-ui";

export const ThreadHeader = memo(function ThreadHeader({
  channel,
  subject,
  trailing,
  onClick,
  isCollapsed,
}: {
  channel: MessageChannel;
  subject?: string | null;
  /** Optional trailing content (e.g., "View recording" button for voice) */
  trailing?: ReactNode;
  /** Optional click handler for collapse/expand */
  onClick?: () => void;
  /** Whether the thread body is collapsed */
  isCollapsed?: boolean;
}) {
  const Icon = MessageChannelIcons[channel];
  const displaySubject = subject || MessageChannelReadable[channel];

  return (
    <Flex
      align="center"
      bgColor="tertiary"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      bottomLeftRadius={isCollapsed ? "sm" : "none"}
      bottomRightRadius={isCollapsed ? "sm" : "none"}
      cursor={onClick ? "pointer" : undefined}
      gap="md"
      hoverColor="secondary"
      justify="space-between"
      onClick={onClick}
      p="xl"
      topLeftRadius="sm"
      topRightRadius="sm"
    >
      <Flex align="center" gap="md" minW="none" overflow="hidden">
        <Flex shrink={0}>
          <RedoIcon color="tertiary" Icon={Icon} size={20} />
        </Flex>
        <Text
          fontSize="sm"
          fontWeight="semibold"
          textColor="primary"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {displaySubject}
        </Text>
      </Flex>
      {trailing && <Flex shrink={0}>{trailing}</Flex>}
    </Flex>
  );
});
